// Маппинг энергозатратности между БД (1,2,3) и отображением (А,Б,В)

export const ENERGY_TO_LABEL = {
  '1': 'А',
  '2': 'Б',
  '3': 'В'
} as const;

export const LABEL_TO_ENERGY = {
  'А': '1',
  'Б': '2',
  'В': '3'
} as const;

export const ENERGY_COLORS = {
  '1': '#ef4444',  // Красный - высокий приоритет (А)
  '2': '#f59e0b',  // Оранжевый - средний приоритет (Б)
  '3': '#10b981'   // Зелёный - низкий приоритет (В)
} as const;

export const ENERGY_DESCRIPTIONS = {
  '1': 'А (сильно затратно, >60 мин)',
  '2': 'Б (средне, 5-60 мин)',
  '3': 'В (легко, <5 мин)'
} as const;

export type EnergyValue = '1' | '2' | '3';
export type EnergyLabel = 'А' | 'Б' | 'В';
